import { Flex, Text } from '@chakra-ui/react';
import { rem } from 'polished';
import { PropsWithChildren } from 'react';

export const DisabledTabItem = ({ children }: PropsWithChildren) => (
  <Flex
    alignItems="center"
    px={0}
    height={{ base: rem(40), md: rem(44) }}
    fontSize={{ base: 'xs', md: 'md' }}
    borderRadius="none"
    color="gray.5"
    bg="none"
    cursor="not-allowed"
  >
    <Text fontWeight="500" noOfLines={1}>
      {children}
    </Text>
  </Flex>
);
